module.exports = __webpack_public_path__ + "static/img/Charlie-Staines.5dfc002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Charlie-Staines.jpg
// module id = 9BBQ
// module chunks = 0